const normalizeProductFilterQuery = (query) => {
  return Object.entries(query || {})
    .filter(([key]) => key.startsWith("*"))
    .flatMap(([key, value]: any) => {
      const [, filterKey] = key.split("*");

      return (
        value?.map((v) => ({
          key: filterKey,
          value: v,
        })) || []
      );
    });
};

export default normalizeProductFilterQuery;
